export const INDEX = "GET_DATA";
export const CLAIM = "CLAIM";